<template>
  <div>
    <Spinner :loading="loading">{{ $t('Fetching Report') }}...</Spinner>
    <v-layout fill-height>
      <v-flex xs2 md3 class="fill-height report--sideCard">
        <Card class="fill-height">
          <v-card-title>
            <span class="title font-weight-light pa-2">{{ $t('REPORTS') }}</span>
            <v-spacer></v-spacer>
            <v-progress-circular v-show="isTemplateLoading" indeterminate color="primary"></v-progress-circular>
          </v-card-title>
          <v-divider></v-divider>
          <v-flex pa-3>
            <div v-if="paramTemplate.length === 0">{{ $t('No template configured') }}</div>
            <v-treeview v-model="templateSelected" :items="paramTemplate" selected-color="#E65100"
              return-object open-on-click hoverable style="overflow: auto">
              <template v-slot:label="{ item }">
                <div :class="{ 'accent--text': isActive(item) }" @click="templateChange(item); " >
                <v-icon v-show="isActive(item)">
                  chevron_right
                </v-icon>
                  {{ $t(item.name) }}
                </div>
              </template>
            </v-treeview>
          </v-flex>
        </Card>
      </v-flex>
      <v-flex xs10 md9>
        <Card class="fill-height" v-if="templateData && templateData.value" >
          <CustomReportTab :templateData="templateData" @table:data="updateTable" @view="viewHandler" @graph:data="updateGraph" @loading:report="loadingStateHandler" :key="componentKey" :dateFormat="currentDateFormat" />
          <Dialog :dialog="dialog" :deviceTab="deviceTab" @download:summary="initialDownload" />
          <TableButtons :dataTitle="dataTitle" />
          <Graph v-if="view == 'graph'" :title="dataTitle" :series="computedSeries" :xAxis="xAxis" :yAxis="computedYAxis" />
          <RecyclerDataTable v-show="view == 'table'" :headers="computedHeaders" :items="computedTableData" :key_field="'date_frame'" v-if="headers.length > 0" />
        </Card>
        <Card class="fill-height" v-else>
          <div class="image">
            <img src="../assets/file.svg" alt="information" height="60%" width="60%">
          </div>
        </Card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
const momentTz = require('moment-timezone')
import moment from 'moment'
import { EventBus } from '@/services/event-bus'

import CustomReportTab from '../components/CustomReport/CustomReportTab'
import Graph from '../components/utility/GraphTemplate'
import TableButtons from '../components/CustomReport/TableButtons'
import Spinner from '../components/CustomReport/Spinner'

import {
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  components: {
    CustomReportTab,
    Graph,
    'Dialog': () => import('@/components/CustomReport/Dialog.vue'),
    TableButtons,
    Spinner,
    'RecyclerDataTable': () =>
      import('@/components/utility/RecyclerDataTable.vue')
  },
  data() {
    return {
      componentKey: 0,
      templateData: {},
      templateSelected: [],
      prevDateFormat: '',
      currentDateFormat: '',
      radioSelected: true,
      loading: false,
      dialog: false,
      deviceTab: [],
      device: ['inv', 'em', 'mfm', 'scb'],
      template: '',
      open: false,
      selectDevice: '',
      view: '',
      headers: [],
      tableData: [],
      options: {
        yAxis: [],
        xAxis: [],
        series: []
      }
    }
  },
  mounted() {
    this.resetState()
    this.loadTemplates(this.getSelectedPlantId)
  },
  beforeDestroy() {
    this.RESET_ACTIVE_FILTER()
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getGeneralState', 'getActivePlantInfo', 'getFilterOptions']),
    ...mapGetters('report', ['getTemplates', 'getSelectedTemplate', 'getRanges', 'isTemplateLoading']),
    activeFilter() {
      return this.getGeneralState('activeFilterOption')
    },
    computedSeries() {
      const clonedSeries = _.cloneDeep(this.options.series)
      return clonedSeries.map(el => {
        el.name = this.$t(el.name)
        return el
      })
    },
    computedYAxis() {
      const clonedYAxis = _.cloneDeep(this.options.yAxis)
      return clonedYAxis.map(el => {
        el.name = this.$t(el.name)
        return el
      })
    },
    computedHeaders() {
      const clonedHeader = _.cloneDeep(this.headers)
      return clonedHeader.map(el => {
        el.key = this.$t(el.key)
        return el
      })
    },
    computedTableData() {
      if (this.tData.length > 0) {
        const clonedData = _.cloneDeep(this.tData)
        const last = clonedData.length -1
        clonedData[last].date_frame = this.$t(clonedData[last].date_frame)
        return clonedData
      } else {
        return []
      }
    },
    filterOption() {
      return this.getFilterOptions['custom-report']
    },
    initialConfig() {
      if (Object.keys(this.getSelectedTemplate).length) {
        let Obj = {}
        this.filterOption.forEach(el => {
          el.children.forEach(child => {
            if ((child.condition && (!!child.considerStateAlways || child.condition(Obj[child.ref]))) || !child.condition) {
              if (child.type === 'select') {
                if (typeof child.value === 'function') {
                  Obj[child.id] = child.value(Obj[child.ref])[0]
                } else {
                  Obj[child.id] = child.value[0]
                }
              } else if (child.type === 'datePicker' || child.type === 'singleDatePicker') {
                let parameters = ['from', 'to']
                parameters.forEach(key => {
                  if (!Obj[child.id]) { Obj[child.id] = {} }
                  Obj[child.id][key] = momentTz().tz(this.getActivePlantInfo('timezone')).format('YYYY-MM-DD')
                })
              } else {
                Obj[child.id] = child.value
              }
            }
          })
        })
        return Obj
      }
      return {}
    },
    paramTemplate() {
      let newArr = [{
        'name': 'Plant Level',
        'id': 'Plant',
        'children': [],
        'node': 'parent'
      }, {
        'name': 'Block Level',
        'id': 'Block',
        'children': [],
        'node': 'parent'
      }, {
        'name': 'Device Level',
        'id': 'Device',
        'children': [],
        'node': 'parent'
      }]
      let filteredArr = []
      if (this.getTemplates.length > 0) {
        newArr.forEach(ar => {
          this.getTemplates.forEach(el => {
            let activeTemplate = el.title.split(' ')
            if (ar['name'].split(' ')[0] == 'Device' && this.device.includes((activeTemplate[0]).toLowerCase())) {
              ar.children.push({
                'name': el.title,
                'id': el.title
              })
            }
            if (ar['name'].split(' ')[0] !== activeTemplate[0]) {
              return
            }
            ar.children.push({
              'name': activeTemplate[1] == 'Level' ? el.title.replace(`${activeTemplate[0]} ${activeTemplate[1]}`, '') : el.title.replace(activeTemplate[0], ''),
              'id': el.title
            })
          })
        })

        filteredArr = newArr.filter(el => el.children.length > 0)
      }
      return filteredArr
    },
    allRange() {
      return this.getRanges ? (this.getSelectedTemplate.showCustomDatePicker ? [...this.getRanges, {
        name: 'Custom',
        interval: 'custom'
      }] : this.getRanges) : []
    },
    showSingleDate() {
      return !!this.getSelectedTemplate.showSingleDate
    },
    selectedTemplateDescription() {
      return this.getSelectedTemplate.description ? this.getSelectedTemplate.description : ''
    },
    dateRange() {
      const dateFrom = moment(this.getGeneralState('activeFilterOption')['Date'].from, 'YYYY-MM-DD')
      const dateTo = moment(this.getGeneralState('activeFilterOption')['Date'].to, 'YYYY-MM-DD')
      const diff = dateTo.diff(dateFrom, 'days')
      if (diff <= 30) {
        return `${this.getGeneralState('activeFilterOption')['Date'].from} - ${this.getGeneralState('activeFilterOption')['Date'].to}`
      } else if (diff <= 365) {
        return `${dateFrom.format('YYYY-MM')} - ${dateTo.format('YYYY-MM')}`
      } else {
        return `${dateFrom.format('YYYY')} - ${dateTo.format('YYYY')}`
      }
    },
    dataTitle() {
      return `${this.$t(this.selectedTemplateDescription)} - ${this.$t(this.getGeneralState('activeFilterOption')['selectedRange'].text)}`
    },
    tData() {
      let newData = this.tableData.map((el, index) => {
        let newDateFormat = Object.assign({}, el)
        if (index + 1 == this.tableData.length) {
          return newDateFormat
        }
        if (!this.currentDateFormat) {
          this.currentDateFormat = this.getGeneralState('activeFilterOption').DateFormat
        }
        newDateFormat['date_frame'] = moment(newDateFormat['date_frame']).format(this.currentDateFormat)
        return newDateFormat
      })

      return newData
    },
    xAxis() {
      let newData = this.options.xAxis.map(date => {
        if (!this.currentDateFormat) {
          this.currentDateFormat = this.getGeneralState('activeFilterOption').DateFormat
        }
        return moment(date).format(this.currentDateFormat)
      })
      return newData
    }
  },
  methods: {
    ...mapActions('report', ['loadTemplates', 'resetState']),
    ...mapMutations('report', ['SET_SELECTED_TEMPLATE']),
    ...mapMutations(['SET_ACTIVE_FILTER', 'RESET_ACTIVE_FILTER']),
    loadingStateHandler(val) {
      this.loading = val
    },
    isActive(item) {
      return this.templateSelected.length > 0 && item.id === this.templateSelected[0].id
    },
    updateTable(val) {
      this.tableData = val.data
      this.headers = val.header
    },
    updateGraph(val) {
      this.options = val
    },
    viewHandler(view) {
      this.view = view
    },
    initialDownload(val) {
      this.dialog = false
      this.chipItems = val
      this.downloadSummary()
    },
    templateChange(templateTemp) {
      if (templateTemp.node !== 'parent') {
        this.templateSelected.length = 0
        this.templateSelected.push(templateTemp)
        this.open = true
      }
    },
    selectTemplate(template) {
      if (template !== undefined) {
        this.SET_SELECTED_TEMPLATE(template)
      }
    }
  },
  watch: {
    templateSelected() {
      this.selectTemplate((this.getTemplates.filter(e => e.title == this.templateSelected[0].id))[0])
    },
    'activeFilter.selectedRange'() {
      this.currentDateFormat = ''
    },
    initialConfig(val) {
      this.RESET_ACTIVE_FILTER()
      this.SET_ACTIVE_FILTER(val)
    },
    getSelectedTemplate() {
      this.tableData.length = 0
      this.headers.length = 0
      this.templateData = {
        value: this.getSelectedTemplate.template,
        level: this.getSelectedTemplate.level,
        deviceTabIndex: this.getSelectedTemplate.deviceTabIndex >= 0 ? this.getSelectedTemplate.deviceTabIndex : null
      }
      this.tableData = []
      this.headers = []
      this.options = {
        yAxis: [],
        xAxis: [],
        series: []
      }
      this.currentDateFormat = ''
      this.componentKey++
    },
    'activeFilter.DateFormat'() {
      this.currentDateFormat = this.activeFilter['DateFormat']
    },
    'activeFilter.Date': {
      handler() {
        this.currentDateFormat = ''
        EventBus.$emit('reset:dateFormat')
      },
      deep: true
    },
    getSelectedPlantId() {
      this.dialog = false
      this.radioSelected = false
      this.headers = []
      this.tableData = []
      this.resetState()
      this.loadTemplates(this.getSelectedPlantId)
    }
  }
}
</script>
<style scoped>
.report--sideCard {
  height: calc(100vh - 11.8rem);
}

.image {
  padding-top: 50px;
  text-align: center;
}
</style>

